// src/redux/features/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { getToken, setToken, removeToken } from "../../routes/cookies";

const initialState = {
  user: null,
  token: getToken(),
  permissions: [],
  isAuthenticated: !!getToken(),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // ✅ Set login (Complete login data)
    setLogin: (state, action) => {
      const { user, token, permissions } = action.payload;
      
      state.user = {
        id: user?.id || null,
        name: user?.name || null,
        email: user?.email || null,
        mobile: user?.mobile || null,
        role: user?.role || 'sub_admin',
        waad_id: user?.waad_id || null,
        waad_name: user?.waad_name || null,
        status: user?.status || 1,
      };
      
      state.token = token;
      state.permissions = permissions || [];
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
      
      if (token) {
        setToken(token);
      }
    },
    
    // ✅ Set user (Only user data, keep token)
    setUser: (state, action) => {
      const userData = action.payload;
      state.user = {
        id: userData?.id || state.user?.id || null,
        name: userData?.name || state.user?.name || null,
        email: userData?.email || state.user?.email || null,
        mobile: userData?.mobile || state.user?.mobile || null,
        role: userData?.role || state.user?.role || 'sub_admin',
        waad_id: userData?.waad_id || state.user?.waad_id || null,
        waad_name: userData?.waad_name || state.user?.waad_name || null,
        status: userData?.status || state.user?.status || 1,
      };
      state.isAuthenticated = true;
    },
    
    // ✅ Set permissions
    setPermissions: (state, action) => {
      state.permissions = action.payload || [];
    },
    
    // ✅ Logout
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.permissions = [];
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      removeToken();
    },
    
    // ✅ Set loading
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    
    // ✅ Set error
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    
    // ✅ Clear error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setLogin,
  setUser,
  setPermissions,
  logout,
  setLoading,
  setError,
  clearError,
} = authSlice.actions;

export default authSlice.reducer;